import {Item} from '../../models/order/item'
export default {
    orderData: state => state.orderData,
    orderList: state => state.orderList,
    orderDetail: state => state.orderDetail,
    // itemDetail: state => state.itemDetail
    itemDetail: state => {
      let obj = {};
      if(state.itemDetail) {
        obj = new Item(state.itemDetail);
      }
      return obj;
    },
    lastOrderRecord: state => state.lastOrderRecord,
}
